import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import {
  FiGrid,
  FiMonitor,
  FiShoppingBag,
  FiHome,
  FiZap,
  FiBook,
  FiSmile,
  FiTool,
  FiActivity,
  FiCamera,
  FiChevronLeft,
  FiChevronRight,
  FiChevronDown,
  TbPerfume,
} from "react-icons/fi";
import { GiPerfumeBottle } from "react-icons/gi";

const categories = [
  // {
  //   id: 1,
  //   label: "Perfumes",
  //   icon: GiPerfumeBottle,
  // },
  {
    id: 2,
    label: "Dubai Perfumes",
    icon: GiPerfumeBottle,
  },
  {
    id: 3,
    label: "Master Perfumes",
    icon: GiPerfumeBottle,
  },
  {
    id: 4,
    label: "Womens Bags",
    icon: FiShoppingBag,
  },
  //   {
  //     id: 3,
  //     label: "Home & Living",
  //     icon: FiHome,
  //     sub: ["Furniture", "Decor", "Kitchen", "Bedding"],
  //   },
];

function CategoryItem({ cat, isActive, onClick, onNavigate }) {
  const [hovered, setHovered] = useState(false);
  const Icon = cat.icon;

  return (
    <button
      onMouseEnter={() => {
        setHovered(true);
        onClick(cat.id);
      }}
      onMouseLeave={() => setHovered(false)}
      onClick={() => onNavigate(cat.label)}
      style={{
        background: "none",
        border: "none",
        color: isActive ? "#e11d48" : hovered ? "#e11d48" : "#444",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        gap: 6,
        padding: "0 14px",
        height: 44,
        borderBottom: isActive ? "2px solid #e11d48" : "2px solid transparent",
        fontSize: 13,
        fontWeight: isActive ? 600 : 400,
        whiteSpace: "nowrap",
        transition: "color 0.15s, border-color 0.15s",
        flexShrink: 0,
      }}
    >
      <Icon size={15} />
      {cat.label}
      {cat.sub && (
        <FiChevronDown
          size={12}
          style={{
            marginLeft: 2,
            opacity: 0.6,
            transform: isActive ? "rotate(180deg)" : "rotate(0deg)",
            transition: "transform 0.2s",
          }}
        />
      )}
    </button>
  );
}

function SubItem({ label }) {
  const [hovered, setHovered] = useState(false);
  return (
    <button
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        background: hovered ? "rgba(225,29,72,0.08)" : "rgba(0,0,0,0.04)",
        border: `1px solid ${hovered ? "rgba(225,29,72,0.3)" : "rgba(0,0,0,0.1)"}`,
        color: hovered ? "#e11d48" : "#555",
        borderRadius: 20,
        padding: "5px 16px",
        fontSize: 13,
        cursor: "pointer",
        transition: "background 0.15s, color 0.15s, border-color 0.15s",
        whiteSpace: "nowrap",
      }}
    >
      {label}
    </button>
  );
}

export default function Header3() {
  const navigate = useNavigate();
  const [activeId, setActiveId] = useState(null);
  const [allOpen, setAllOpen] = useState(false);
  const [allHovered, setAllHovered] = useState(false);
  const scrollRef = useRef(null);
  const containerRef = useRef(null);

  const activeCategory = categories.find((c) => c.id === activeId);

  const scroll = (dir) => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: dir * 200, behavior: "smooth" });
    }
  };

  const handleSelect = (id) => {
    setAllOpen(false);
    setActiveId(id);
  };

  const navigateToCategory = (label) => {
    navigate(`/category/${label.toLowerCase().replace(/\s+/g, "-")}`);
  };

  return (
    <div
      ref={containerRef}
      onMouseLeave={() => {
        setActiveId(null);
        setAllOpen(false);
      }}
      style={{
        backgroundColor: "#ffffff",
        borderTop: "1px solid rgba(0,0,0,0.07)",
        borderBottom: "1px solid rgba(0,0,0,0.07)",
        position: "relative",
      }}
    >
      {/* ── Main categories bar ── */}
      <div style={{ display: "flex", alignItems: "center", height: 44 }}>
        {/* All Categories button */}
        <div style={{ position: "relative", flexShrink: 0 }}>
          <button
            onMouseEnter={() => {
              setAllHovered(true);
              setAllOpen(true);
              setActiveId(null);
            }}
            onMouseLeave={() => setAllHovered(false)}
            onClick={() => setAllOpen((o) => !o)}
            className="h3-all-cats-btn"
            style={{
              background:
                allOpen || allHovered ? "rgba(225,29,72,0.06)" : "none",
              border: "none",
              color: allOpen || allHovered ? "#e11d48" : "#333",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: 7,
              padding: "0 16px",
              height: 44,
              fontSize: 13,
              fontWeight: 600,
              whiteSpace: "nowrap",
              transition: "background 0.15s, color 0.15s",
              borderRight: "1px solid rgba(0,0,0,0.07)",
            }}
          >
            <FiGrid size={15} />
            <span className="h3-cats-label">All Categories</span>
            <FiChevronDown
              size={12}
              style={{
                marginLeft: 2,
                transform: allOpen ? "rotate(180deg)" : "rotate(0deg)",
                transition: "transform 0.2s",
              }}
            />
          </button>

          {allOpen && (
            <div
              className="h3-dropdown"
              style={{
                position: "absolute",
                top: "100%",
                left: 0,
                background: "#ffffff",
                border: "1px solid rgba(0,0,0,0.1)",
                borderRadius: 8,
                overflow: "hidden",
                minWidth: 220,
                zIndex: 1000,
                boxShadow: "0 8px 24px rgba(0,0,0,0.1)",
              }}
            >
              {categories.map((cat) => {
                const Icon = cat.icon;
                return (
                  <button
                    key={cat.id}
                    onClick={() => {
                      handleSelect(cat.id);
                      setAllOpen(false);
                      navigateToCategory(cat.label);
                    }}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 10,
                      width: "100%",
                      background:
                        activeId === cat.id ? "rgba(225,29,72,0.06)" : "none",
                      border: "none",
                      color: activeId === cat.id ? "#e11d48" : "#333",
                      padding: "10px 18px",
                      textAlign: "left",
                      cursor: "pointer",
                      fontSize: 13,
                      transition: "background 0.15s, color 0.15s",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = "rgba(225,29,72,0.06)";
                      e.currentTarget.style.color = "#e11d48";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background =
                        activeId === cat.id ? "rgba(225,29,72,0.06)" : "none";
                      e.currentTarget.style.color =
                        activeId === cat.id ? "#e11d48" : "#333";
                    }}
                  >
                    <Icon size={15} />
                    {cat.label}
                  </button>
                );
              })}
            </div>
          )}
        </div>

        {/* Scroll left */}
        <button
          onClick={() => scroll(-1)}
          className="h3-scroll-arrow"
          style={{
            background: "none",
            border: "none",
            color: "rgba(0,0,0,0.35)",
            cursor: "pointer",
            padding: "0 6px",
            height: 44,
            flexShrink: 0,
            display: "flex",
            alignItems: "center",
          }}
        >
          <FiChevronLeft size={16} />
        </button>

        {/* Scrollable list */}
        <div
          ref={scrollRef}
          style={{
            display: "flex",
            alignItems: "center",
            overflowX: "auto",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
            flex: 1,
          }}
        >
          {categories.map((cat) => (
            <CategoryItem
              key={cat.id}
              cat={cat}
              isActive={activeId === cat.id}
              onClick={handleSelect}
              onNavigate={navigateToCategory}
            />
          ))}
        </div>

        {/* Scroll right */}
        <button
          onClick={() => scroll(1)}
          className="h3-scroll-arrow"
          style={{
            background: "none",
            border: "none",
            color: "rgba(0,0,0,0.35)",
            cursor: "pointer",
            padding: "0 6px",
            height: 44,
            flexShrink: 0,
            display: "flex",
            alignItems: "center",
          }}
        >
          <FiChevronRight size={16} />
        </button>
      </div>

      <style>{`
        .h3-cats-label { white-space: nowrap; }
        .h3-scroll-arrow { display: flex; }
        .h3-dropdown { min-width: 220px; }
        @media (max-width: 580px) {
          .h3-cats-label { display: none; }
          .h3-all-cats-btn { padding: 0 10px !important; gap: 4px !important; }
          .h3-scroll-arrow { display: none !important; }
          .h3-dropdown { min-width: 0; width: calc(100vw - 24px); max-width: 280px; }
        }
      `}</style>

      {/* ── Subcategories panel ── */}
      {activeCategory?.sub && (
        <div
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            right: 0,
            backgroundColor: "#fafafa",
            borderTop: "1px solid rgba(0,0,0,0.07)",
            borderBottom: "1px solid rgba(0,0,0,0.07)",
            boxShadow: "0 6px 20px rgba(0,0,0,0.07)",
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 8,
            padding: "10px 16px",
            zIndex: 999,
          }}
        >
          {activeCategory.sub.map((sub) => (
            <SubItem key={sub} label={sub} />
          ))}
        </div>
      )}
    </div>
  );
}
